import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const listUserQueryProject = (listData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_USER_QUERY_PROJECT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/user-query-project/list`,
        listData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_USER_QUERY_PROJECT_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "LIST_USER_QUERY_PROJECT_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_USER_QUERY_PROJECT_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addUserQueryProject = (addData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_USER_QUERY_PROJECT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/user-query-project/add`,
        addData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_USER_QUERY_PROJECT_SUCCESS", payload: data });
        toast.success(data?.message || "Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_USER_QUERY_PROJECT_FAILED", payload: data });
        toast.error(data?.message || "Something went wrong");
      }
    } catch (error) {
      dispatch({
        type: "ADD_USER_QUERY_PROJECT_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Add failed!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateUserQueryProject = (id, updateData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_USER_QUERY_PROJECT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.put(
        `${BASE_URL}/user-query-project/update/${id}`,
        updateData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_USER_QUERY_PROJECT_SUCCESS", payload: data });
        toast.success(data?.message || "Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_USER_QUERY_PROJECT_FAILED", payload: data });
        toast.error(data?.message || "Something went wrong");
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_USER_QUERY_PROJECT_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Update failed!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewUserQueryProject = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VIEW_USER_QUERY_PROJECT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/user-query-project/view/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_USER_QUERY_PROJECT_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_USER_QUERY_PROJECT_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_USER_QUERY_PROJECT_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Failed to load details");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const deleteUserQueryProject = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DELETE_USER_QUERY_PROJECT_REQUEST" });

      const { data } = await axios.delete(
        `${BASE_URL}/user-query-project/delete/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "DELETE_USER_QUERY_PROJECT_SUCCESS", payload: data });
        toast.success(data?.message || "Deleted Successfully!!");
        return data;
      } else {
        dispatch({ type: "DELETE_USER_QUERY_PROJECT_FAILED", payload: data });
        toast.error(data?.message || "Something went wrong");
      }
    } catch (error) {
      dispatch({
        type: "DELETE_USER_QUERY_PROJECT_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
      toast.error(error?.response?.data?.message || "Delete failed!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};